module.exports = __webpack_public_path__ + "static/media/F3.52de4d6a.png";